import { navbarEn } from "./en/navbar";

export const enTexts = {
    navbar: navbarEn,
};
